module.exports = __webpack_public_path__ + "img/ic_heart_border.c1958b1d.svg";